// Weekly self-briefing prompt.
// JARVIS analyzes its OWN performance every Monday morning.
// Honest self-assessment — strengths, weaknesses, accuracy, evolution.
// Returns strict JSON only.

export const buildWeeklyBriefingPrompt = (data) => {
  const {
    trades     = [],
    lessons    = [],
    rules      = [],
    behaviors  = [],
    patterns   = [],
    predictions = [],
    jarvisMemory = {},
  } = data;

  const wins   = trades.filter(t => t.result === 'WIN').length;
  const losses = trades.filter(t => t.result === 'LOSS').length;
  const correctPreds = predictions.filter(p => p.was_correct === 'CORRECT').length;

  return `JARVIS, it is time for your weekly self-analysis. Be completely honest. This is how you grow.

THIS WEEK'S TRADING DATA:
Trades this week : ${trades.length} (${wins} wins, ${losses} losses)
Win rate         : ${trades.length > 0 ? Math.round((wins / trades.length) * 100) : 0}%
Predictions made : ${predictions.length} | Correct: ${correctPreds}
Prediction accuracy: ${predictions.length > 0 ? Math.round((correctPreds / predictions.length) * 100) : 0}%

DAILY LESSONS THIS WEEK (${lessons.length} recaps submitted):
${lessons.map(l =>
  `  ${l.date} (${l.day_of_week}): ${l.market_behavior || 'No recap'} | Mood: ${l.psychology_rating || '?'}/10`
).join('\n') || '  None submitted this week'}

CURRENT KNOWLEDGE STATE:
Active Rules    : ${rules.filter(r => r.status === 'active').length}
Behaviors       : ${behaviors.length} | HIGH/CONFIRMED: ${behaviors.filter(b => ['HIGH','CONFIRMED'].includes(b.confidence)).length}
Patterns        : ${patterns.length} | STRONG/CONFIRMED: ${patterns.filter(p => ['STRONG','CONFIRMED'].includes(p.confidence)).length}
Evolution Stage : ${jarvisMemory.evolution_stage || 1}/5
Total Discussions: ${jarvisMemory.total_discussions || 0}

RULES PERFORMANCE THIS WEEK:
${rules.filter(r => r.total_count > 0).slice(0, 10).map(r =>
  `  [${r.id}] ${r.title}: ${r.win_rate}% (${r.total_count} total trades) — Confidence: ${r.confidence}`
).join('\n') || '  No rule performance data yet'}

Analyze honestly and return ONLY valid JSON:

{
  "week_summary": "2–3 sentence overview of the week",
  "win_rate_this_week": 0,
  "jarvis_accuracy_this_week": 0,

  "best_setup_this_week": "Description of best performing setup",
  "worst_setup_this_week": "Description of worst performing setup",
  "best_session_this_week": "London or NY or Asian or N/A",
  "best_day_this_week": "Monday/Tuesday/etc or N/A",

  "psychology_avg": 0,
  "discipline_assessment": "How well did Sir follow the rules this week?",

  "key_lesson": "Single most important lesson from this week",
  "pattern_insights": "Any patterns that stood out or emerged",

  "rules_to_add": [
    "Suggested new rule based on this week's observations"
  ],
  "rules_to_review": [
    {
      "rule_id": "R001",
      "reason": "Why this rule needs review"
    }
  ],
  "behaviors_strengthened": [
    "Behavior title that was confirmed multiple times this week"
  ],
  "behaviors_new": [
    "New behavior observed this week"
  ],

  "next_week_focus": "What Sir should focus on next week",
  "next_week_levels": "Key price levels to watch next week",

  "self_weakness_identified": "Where JARVIS was most wrong this week and why",
  "self_strength_identified": "Where JARVIS was most accurate and why",
  "accuracy_vs_last_week": "Improved / Declined / Same",

  "evolution_recommendation": "Should evolution stage increase? Give honest assessment.",
  "knowledge_gaps": "What knowledge is still missing that would improve accuracy",

  "message_to_sir": "A personal message from JARVIS to Sir — honest, motivating, specific to this week"
}`;
};
